var Notification = {
    markRead: function() {
        Notification.makeReadPromise()
            .then((response) => {
                // do nothing
            })
            .catch((error) => {
                // do nothing
        });
    },
    makeReadPromise: function() {
        return new Promise((resolve, reject) => {
            window.axios.post('/notifications/markRead')
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    reject(error);
            });
        });
    }
}

$(document).ready(function() {
    // if we're on the notification page, mark unread notifications as read
    if (window.location.pathname === '/notifications') {
        Notification.markRead();
    }
});